import type { SVGProps } from 'react';
export const Tag = (props: SVGProps<SVGSVGElement>) => (
  <svg width="1rem" height="1rem" fill="currentColor" viewBox="0 0 20 20" {...props}>
    <path
      fillRule="evenodd"
      d="M10.64 3.02a1.2 1.2 0 0 0-1.04.32L3.34 9.6a1.15 1.15 0 0 0 0 1.64l5.42 5.42a1.15 1.15 0 0 0 1.64 0l6.26-6.26a1.2 1.2 0 0 0 .32-1.04L16 4.52a.7.7 0 0 0-.53-.53zm4.13 2.2.86 4.3-6.05 6.04-5.14-5.14 6.04-6.05z"
      clipRule="evenodd"
    />
    <path d="M12.83 7.77a.6.6 0 1 1 0-1.2.6.6 0 0 1 0 1.2" />
  </svg>
);
